import { useTranslation } from 'react-i18next'

import './siteLanguages.css';
import FlagButton from './FlagButton';

export default function SiteLanguages() {
  const { i18n } = useTranslation('translation', { useSuspense: false });


  return (
    <div className='site-languages'>
      {Object.keys(i18n.options.resources).map((lang) => {
        return <FlagButton key={lang} language={lang} />
      })}
    </div>
  )
}
